import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from '../../../../../sentry';
import { LocationEnvironmentApi } from '../../../../core/api/location-environment/location-environment.api';
import { AuthenticationService } from '../../../../core/authentication/authentication.service';
import { CustomMessagesService } from '../../../../core/errors/custom-messages.service';
import { locationEnvironmentNameUniqueAsyncValidator } from './dialog-location-environment.validator';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogLocationEnvironmentComponent = /** @class */ (function () {
    function DialogLocationEnvironmentComponent(data, formBuilder, translationLoader, locationEnvironmentApi, messageService, matDialogRef, authenticationService) {
        this.data = data;
        this.formBuilder = formBuilder;
        this.translationLoader = translationLoader;
        this.locationEnvironmentApi = locationEnvironmentApi;
        this.messageService = messageService;
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.isUpdate = false;
        this.isLoading = false;
        this.isViewMode = !this.authenticationService.hasPermission('locations-edit');
        this.translationLoader.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogLocationEnvironmentComponent.prototype.ngOnInit = function () {
        this.locationEnvironmentForm = this.formBuilder.group({
            name: new FormControl(this.data.locationEnvironment.name, {
                validators: [Validators.required, Validators.maxLength(100)],
                asyncValidators: [
                    locationEnvironmentNameUniqueAsyncValidator({
                        locationSectorId: this.data.locationEnvironment.locationSector && this.data.locationEnvironment.locationSector.id,
                        locationEnvironmentId: this.data.locationEnvironment.id,
                        locationEnvironmentApi: this.locationEnvironmentApi
                    })
                ]
            }),
            location: new FormControl(this.data.locationEnvironment.location, [Validators.required]),
            locationSector: new FormControl(this.data.locationEnvironment.locationSector, [Validators.required]),
            description: [this.data.locationEnvironment.description, [Validators.maxLength(2000)]],
            qrCode: [this.data.locationEnvironment.qrCode, [Validators.required]]
        });
        this.locationEnvironmentForm.get('location').disable();
        if (this.data.locationEnvironment.locationSector) {
            this.locationEnvironmentForm.get('locationSector').disable();
        }
        if (this.isViewMode) {
            this.locationEnvironmentForm.disable();
        }
    };
    DialogLocationEnvironmentComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationEnvironment, _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        this.isLoading = true;
                        if (!this.data.locationEnvironment.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.locationEnvironmentApi.update(this.prepareUpdateInput())];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.locationEnvironmentApi.create(this.prepareCreateInput())];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        locationEnvironment = _a;
                        this.messageService.success('LOCATION_ENVIRONMENT_DIALOG.MESSAGE.SUCCESS');
                        this.matDialogRef.close({ reload: true, locationEnvironment: locationEnvironment });
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        sentry.captureException(error_1);
                        this.messageService.error(error_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationEnvironmentComponent.prototype.prepareCreateInput = function () {
        var form = this.locationEnvironmentForm.getRawValue();
        return {
            name: form.name,
            description: form.description,
            qrCode: form.qrCode,
            locationSectorId: form.locationSector.id
        };
    };
    DialogLocationEnvironmentComponent.prototype.prepareUpdateInput = function () {
        var form = this.locationEnvironmentForm.getRawValue();
        return {
            id: this.data.locationEnvironment.id,
            name: form.name,
            description: form.description,
        };
    };
    return DialogLocationEnvironmentComponent;
}());
export { DialogLocationEnvironmentComponent };
